(function () {
  const FREEBIE_MAX_PRICE_PAISE = 100;

  const checkAndFixFreebies = async () => {
    try {
      const fetchFn = window.__originalFetch || window.fetch;
      const response = await fetchFn('/cart.js');
      const cart = await response.json();
      const updates = {};

      for (const item of cart.items) {
        if (item.price <= FREEBIE_MAX_PRICE_PAISE && item.quantity > 1) {
          updates[item.key] = 1;
        }
      }

      if (Object.keys(updates).length > 0) {
        await fetchFn('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        });
      }
    } catch (err) {
      console.warn('[FreebieLimit] Error:', err);
    }
  };

  const blockXhrCartFromConsole = () => {
    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this._freebieUrl = typeof url === 'string' ? url : '';
      return origOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (...sendArgs) {
      const isCartEndpoint = ['/cart/add.js', '/cart/update.js', '/cart/change.js']
        .some((path) => this._freebieUrl.includes(path));

      if (isCartEndpoint) {
        const stack = new Error().stack || '';
        const isFromConsole = stack.includes('at <anonymous>') || stack.includes('VM');
        if (isFromConsole) {
          console.warn('[FreebieLimit] Blocked XHR cart call from console');
          return;
        }
      }
      return origSend.apply(this, sendArgs);
    };
  };

  const init = () => {
    blockXhrCartFromConsole();
    checkAndFixFreebies();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
